<template>
  <div class="whiteList-container div-layout">
    <module-title title="白名单">
      <div class="right">
        <span class="warning">
          <i class="el-alert__icon el-icon-warning" />
          白名单列表账号：登录优智多家长端APP、课桌先生时短信验证码免验证。
        </span>
        <el-button type="primary" size="medium" @click="columnAddOrEdit('add')">
          添加
        </el-button>
      </div>
    </module-title>
    <div class="whiteList-right-contain">
      <div>
        <BaseTable
          v-loading="listLoading"
          class="list-table"
          :columns="columns"
          :data="dataList"
          border
        >
          <template #default="scope">
            <el-button
              type="danger"
              size="small"
              @click="handleDelete(scope.row)"
            >
              删除
            </el-button>
          </template>
        </BaseTable>
        <pagination
          :total="searchForm.total"
          :page.sync="searchForm.pageNum"
          :limit.sync="searchForm.pageSize"
          @pagination="pageCurriculumList"
          @handleSizeChange="handleSizeChange"
        />
      </div>
    </div>
    <!-- 新增编辑 -->
    <el-dialog
      v-if="hiddenVariable.dialogEditVisible"
      :close-on-click-modal="false"
      :visible.sync="hiddenVariable.dialogEditVisible"
      :title="hiddenVariable.title"
      width="650px"
    >
      <dialog-info
        :type="hiddenVariable.type"
        :data-list="hiddenVariable.text"
        @closeDialog="closeDialogFn"
      />
    </el-dialog>
  </div>
</template>

<script>

import DialogInfo from './components/dialogInfo';
import { ColumnsWhite } from '../store';
import { mapGetters } from 'vuex';
import {
  whiteList,
  whiteListDel
} from '@/api/productOperation/mrDesk/whiteList';
export default {
  name: 'ActorStudyManage',
  components: {
    DialogInfo
  },
  data() {
    return {
      // 弹框标题
      // 所有控制显示隐藏变量
      hiddenVariable: {
        dialogEditVisible: false, // 学生详情
        type: 'add',
        id: '',
        title: '',
        text: {}
      },
      // 搜索表单
      searchForm: {
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      dataList: [],
      listLoading: false, // 表格刷新loading
      columns: ColumnsWhite
    };
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.getList();
    },

    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.getList();
    },

    // 获取列表名单
    getList() {
      var option = {
        ...this.searchForm
      };
      delete option.total;
      whiteList(option).then((res) => {
        if (res.data && res.data.list && res.data.list.length > 0) {
          var i = 0;
          res.data.list.map((item, index) => {
            if (item.status === '1') {
              i = index;
            }
            item.switchUpDown = true;
            return item;
          });
          res.data.list[i].switchUpDown = false;
          this.dataList = res.data.list;
          this.searchForm.total = res.data.total;
        } else {
          this.dataList = [];
        }
      });
    },
    // 添加加编辑
    columnAddOrEdit(val, row) {
      this.ajaxLoading = false;
      this.hiddenVariable.title = '添加';
      this.hiddenVariable.type = 'add';
      this.hiddenVariable.text = {};
      this.hiddenVariable.dialogEditVisible = true;
    },
    // 删除
    handleDelete(row) {
      this.$confirm(`确定要删除该白名单么?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const form = {
            mobile: row.mobile
          };
          return whiteListDel(form);
        })
        .then((res) => {
          this.$notify.success({
            title: 'Success',
            message: '删除成功',
            showClose: false,
            duration: 2000
          });
          this.getList();
        })
        .catch(() => {});
    },
    // 弹框关闭
    closeDialogFn() {
      this.hiddenVariable.dialogEditVisible = false;
      this.getList();
    }
  }
};
</script>
<style lang="scss" scoped>
.whiteList-container {
  .edit-form-input {
    width: 6.8vw;
  }
  .textCenter {
    text-align: center;
    padding: 20px;
    .el-button {
      width: 160px;
    }
  }

  // .handle-form-input{ width: 160px;}
  // 查看详情
  .archivesTitle {
    color: #1890ff;
    font-size: 14px;
    font-weight: bold;
    padding-left: 30px;
    padding-bottom: 20px;
  }
  .red {
    color: red;
  }
  .warning {
    margin: 20px 20px 0 0;
    padding: 8px 16px;
    border-radius: 4px;
    background-color: #fdf6ec;
    color: #e6a23c;
  }
  .manager-info {
    ul {
      margin-left: 60px;
      width: 50%;
      min-width: 220px;
      li {
        margin-bottom: 20px;
      }
    }
  }
}
</style>
